import styled from 'styled-components';

import { TextButton } from '@riac/design-system';
import { PhoneSelect } from '../CatalogTextAlerts/TextAlertModal/TextAlertModal.style';


export const CatalogWishlistsSelect = styled(PhoneSelect)``;

export const ViewWishlistButton = styled(TextButton)`
  font-size: 1.6rem;
  margin-bottom: 10px;
`;
